export default "__VITE_ASSET__CDDw1K$X__"